import { render } from "./CookieConsent.vue?vue&type=template&id=6558e2c1&scoped=true"
import script from "./CookieConsent.vue?vue&type=script&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&lang=ts"

import "./CookieConsent.vue?vue&type=style&index=0&id=6558e2c1&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6558e2c1"

export default script